"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var swiper_1 = require("swiper");
var react_2 = require("swiper/react");
var styles_module_scss_1 = __importDefault(require("../MainBanner/styles.module.scss"));
var styles_module_scss_2 = __importDefault(require("./styles.module.scss"));
require("./styles.scss");
var MainBannerSlider = function (_a) {
    var slides = _a.slides, className = _a.className;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var hasBreakpoints = Object.keys(breakpoints).length > 0;
    var isMobile = hasBreakpoints && breakpoints.mobile;
    var isTablet = hasBreakpoints && breakpoints.tablet;
    var containerStyle = isMobile
        ? { aspectRatio: '563 / 436', height: 'auto' }
        : isTablet
            ? { aspectRatio: '4000 / 1030', height: 'auto' }
            : undefined;
    if (!slides.length)
        return null;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles_module_scss_1.default.container, styles_module_scss_2.default.container, 'main-banner-slider', className), style: containerStyle },
        react_1.default.createElement(react_2.Swiper, { modules: [swiper_1.Autoplay, swiper_1.Pagination], slidesPerView: 1, pagination: slides.length > 1 ? { clickable: true } : false, loop: slides.length > 1, autoplay: slides.length > 1
                ? { delay: 5000, disableOnInteraction: false }
                : false, className: styles_module_scss_2.default.swiper }, slides.map(function (slide, idx) {
            var image = isMobile && slide.backgroundImageMobile
                ? slide.backgroundImageMobile
                : slide.backgroundImage;
            var backgroundImage = image.includes('url(')
                ? image
                : "url(".concat(image, ")");
            return (react_1.default.createElement(react_2.SwiperSlide, { key: slide.id || "mainBannerSlide_".concat(idx), className: styles_module_scss_2.default.slide },
                react_1.default.createElement("a", { className: styles_module_scss_2.default.slideLink, href: slide.href, rel: "noopener noreferrer", style: { backgroundImage: backgroundImage } })));
        }))));
};
exports.default = MainBannerSlider;
